import $ from 'jquery';
import grecaptcha from '@ppcp/recaptcha-external';
import {getSetting} from '@ppcp/utils';
import Actions from '@ppcp/actions';

const actions = new Actions();

const settings = getSetting('recaptcha');

const TOKEN_TTL = 30000; // 30 seconds

const getTokenInput = () => $('[name="ppcp_recaptcha_response"]');

const setToken = (token, $form) => {
    let $input = getTokenInput();
    if (!$input.length) {
        $input = $('<input type="hidden" name="ppcp_recaptcha_response"/>').appendTo($form);
    }
    $input.val(token).attr('data-token-time', Date.now());
};

const clearToken = () => {
    getTokenInput().val('').removeAttr('data-token-time');
};

const isTokenValid = () => {
    const $input = getTokenInput();
    if (!$input.val()) return false;
    const tokenTime = parseInt($input.attr('data-token-time') || '0', 10);
    return (Date.now() - tokenTime) < TOKEN_TTL;
};

const getPaymentMethod = ($form) => $form.find('[name="payment_method"]:checked').val();

const createToken = async () => {
    await new Promise(resolve => grecaptcha.ready(resolve));
    return await grecaptcha.execute(settings.site_key, {action: 'submit'});
}

actions.addFilter('create_order_data', async (data) => {
    if (!settings.paymentMethods.includes(data?.payment_method)) {
        return data;
    }
    const token = await createToken();
    return {
        ...data,
        ppcp_recaptcha_response: token
    }
});

actions.addFilter('add_to_cart_data', async (data) => {
    if (!settings.paymentMethods.includes(data?.payment_method)) {
        return data;
    }
    const token = await createToken();
    return {
        ...data,
        ppcp_recaptcha_response: token
    }
});

actions.addFilter('create_vault_token_data', async (data) => {
    if (!settings.paymentMethods.includes(data?.payment_method)) {
        return data;
    }
    const token = await createToken();
    return {
        ...data,
        ppcp_recaptcha_response: token
    }
});

actions.addFilter('create_billing_agreement_data', async (data) => {
    if (!settings.paymentMethods.includes(data?.payment_method)) {
        return data;
    }
    const token = await createToken();
    return {
        ...data,
        ppcp_recaptcha_response: token
    }
});

